import { ColorPicker as FColorPicker } from '@forest/forms';
import { connect, mapProps, mapReadPretty } from '@formily/react';
import { PreviewText } from '../PreviewText';
export const ColorPicker = connect(FColorPicker, mapProps({
    dataSource: 'options',
}), mapReadPretty(PreviewText.Select));
export default ColorPicker;
